import NavigationBar from "../Components/NavigationBar";
import Footer from "../Components/Footer";
import "../CSS/ProfilePage.css";
import { useState } from "react";
import { getAuth, updatePassword } from "firebase/auth";

function ProfilePage() {
  const auth = getAuth();
  const user = auth.currentUser;

  const [data, setData] = useState({
    name: localStorage.getItem('UserName') || '',
    mobile: localStorage.getItem('UserMobile') || '',
    email: localStorage.getItem('UserEmail') || '',
    newPassword: '',
    confirmPassword: '',
  });

  const [passwordError, setPasswordError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
    if (name === "newPassword" || name === "confirmPassword") {
      setPasswordError("");
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSuccessMessage(""); // Clear previous success message
    if (data.newPassword !== data.confirmPassword) {
      setPasswordError("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      await updatePassword(user, data.newPassword);
      setPasswordError("");
      setSuccessMessage("Password updated successfully");
    } catch (error) {
      setPasswordError("Failed to update password");
      console.error("Error updating password:", error);
    }
    setLoading(false);
  };

  return (
    <div className="ProfilePageOuterWrap">
      <NavigationBar />
      <div className="ProfilePageInnerWrap">
        <h1 className="ProfileHeader">Profile</h1>
        <form onSubmit={handleSave}>
          <label className="label Profilename" htmlFor="name">Name: </label>
          <input
            className="input ProfilenameInput"
            name="name"
            type="text"
            value={data.name}
            disabled
          /> <br />
          
          <label className="label ProfileNumber" htmlFor="mobile">Phone: </label>
          <input
            className="input ProfileNumberInput"
            name="mobile"
            type="text"
            value={data.mobile}
            onChange={handleInputChange}
          /> <br />
          
          <label className="label ProfileEmail" htmlFor="email">Email: </label>
          <input
            className="input ProfileEmailInput"
            name="email"
            type="email"
            value={data.email}
            disabled
          /> <br />
          
          <label className="label ProfilePassword" htmlFor="newPassword">New Password: </label>
          <input
            className="input ProfilePasswordInput"
            name="newPassword"
            type="password"
            value={data.newPassword}
            onChange={handleInputChange}
          /> <br />
          
          <label className="label ProfilePassword" htmlFor="confirmPassword">Confirm Password: </label>
          <input
            className="input ProfileCPasswordInput"
            name="confirmPassword"
            type="password"
            value={data.confirmPassword}
            onChange={handleInputChange}
          /> <br />

          {passwordError && <p style={{ color: 'red' }}>{passwordError}</p>}
          {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}

          <button className="ProfileSubmitBtn" type="submit" disabled={isLoading}>
            {isLoading ? "Saving..." : "Save"}
          </button>
        </form>
      </div>
      <div className="ProfileFooterWrap">
        <Footer />
      </div>
    </div>
  );
}

export default ProfilePage;
